import { render, staticRenderFns } from "./suPriceList.vue?vue&type=template&id=b543b486"
import script from "./suPriceList.vue?vue&type=script&lang=js"
export * from "./suPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports